










































































































































import { Component, Watch, Mixins, Ref } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";
import { VIPCertificateEditViewMixin } from "@/mixins/VIPCertificateMixin";
import dayjs from "dayjs";
import CertificateWorkEdit from "../component/certificate/CertificateWorkEdit.vue";
import CertificateAbilityEdit from "../component/certificate/CertificateAbilityEdit.vue";
import CertificatePdfModal from "../component/certificate/CertificatePdfModal.vue";
import UploadFileModal from "../component/UploadFileModal.vue";
import EventsSidebar from "../component/event/EventsSidebar.vue";
import EventableModal from "../../../component/EventableModal.vue"
import {
	db,
	auth,
	busy,
	DEBUG,
	toaster,
	VIPCertificate,
	VipCertificateStatus,
	VIPCertificateIpRest,
	VIPCertificateRest,
	VIPProjectRest,
	VIPCertificateEventRest,
	getNextVipCertificateStatus,
	VIPCompanyRest,
	createEventInfo,
} from "@/loader/public";
import CertificateEdit from '../component/certificate/CertificateEdit';

@Component({
	name: "CertificateView",
	components: {
		CertificateWorkEdit,
		CertificateAbilityEdit,
		CertificatePdfModal,
		EventsSidebar,
		UploadFileModal,
		EventableModal,
	}
})
export default class CertificateView extends Mixins(VIPCertificateEditViewMixin({
	editCap: "edit_vip_certificate",
	createCap: "create_vip_certificate",
	deleteCap: "delete_vip_certificate",
	loadMessage: "Chargement du certificat ...",
	redirection: { name: "Certificates" },
	getParams: {
		options: {
			project: {
				company: {
					contacts: true
				},
				ips: true,
				manager: true
			},
			ips: true,
			events: { event: true }
		}
	},
})) {
	// public item: VIPCertificate | null = null;
	// public editCap = "edit_vip_certificate";
	// public createCap = "create_vip_certificate";
	// public deleteCap = "delete_vip_certificate";
	// public dbType = DBType.certificates;
	// public rest = VIPCertificateRest;
	// public invalidFeedbacks = {};
	// public focused = {};
	// public loadMessage = "Chargement du certificat ...";
	// public redirection = { name: "Certificates" };
	// public getParams: IVIPCertificateRestGetParams = {
	// 	options: {
	// 		project: {
	// 			company: {
	// 				contacts: true
	// 			},
	// 			ips: true,
	// 			manager: true
	// 		},
	// 		ips: true,
	// 		events: { event: true }
	// 	}
	// }

	@Ref()
	public editor!: CertificateEdit;

	public statuses = VipCertificateStatus;
	private status: VipCertificateStatus | null = null;
	public date: string | null = null;

	public get token() {
		return auth.token;
	}

	public get canDelete(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.delete_vip_certificate && (
			!this.item.isSigned || auth.user.isManagerOrAbove
		);
	}

	public get canEdit(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate && (
			(this.item.isDraft && auth.user.isSupervisorOrAbove)
			|| (this.item.isChecking && auth.user.isAdministrativeOrAbove)
			|| (this.item.isValidating && auth.user.isManagerOrAbove)
		);
	}

	public get canGenerate(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate && (
			this.item.isDraft
			|| this.item.isChecking
			|| this.item.isValidating
			|| this.item.isSending
		);
	}

	public get canAskModif(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate && (
			(this.item.isChecking && auth.user.isAdministrativeOrAbove)
			|| (this.item.isValidating && auth.user.isManagerOrAbove)
			|| (this.item.isSending && auth.user.isSupervisorOrAbove)
			|| (this.item.isAwaiting && auth.user.isSupervisorOrAbove)
			|| (this.item.isAbandonned && auth.user.isManagerOrAbove)
		);
	}

	public get canAskChecking(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate && this.item.isDraft;
	}

	public get canAskValidation(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate && this.item.isChecking
			&& (auth.user.isAdministrativeOrAbove || auth.user.isManagerOrAbove);
	}

	public get canValidate(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate
			&& (this.item.isDraft || this.item.isChecking || this.item.isValidating)
			&& auth.user.isManagerOrAbove;
	}

	public get canSend(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate
			&& this.item.isSending
			&& auth.user.isSupervisorOrAbove;
	}

	public get canUpload(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.edit_vip_certificate
			&& (this.item.isAwaiting || this.item.isSigned)
			&& auth.user.isSupervisorOrAbove;
	}

	public get certificateComponent() {
		return this.item?.isTypeAbilityCertificate ? CertificateAbilityEdit : CertificateWorkEdit;
	}

	public get productions(): string[] {
		return db.productions.list.sort((a, b) => a.name.localeCompare(b.name)).map(p => p.name);
	}

	public setDate(value: string | null) {
		DEBUG && console.log("setDate", { oldValue: this.date, newValue: value });
		this.date = value;
	}

	public validate() {
		if (this.item) {
			let status = getNextVipCertificateStatus(this.item.status);
			if (status) {
				this.changeStatus(status);
			}
		}
	}

	public askModification() {
		if (this.item && this.canAskModif) {
			this.changeStatus(VipCertificateStatus.draft);
		} else {
			console.log({ item: this.item, canAskModif: this.canAskModif });
		}
	}

	public changeStatus(status: VipCertificateStatus) {
		if (this.item) {
			this.status = status;
			this.item.event = createEventInfo();
			this.$bvModal.show("eventable_modal");
		}
	}

	public confirmChangeStatus(event: BvModalEvent) {
		if (this.item) {
			busy.start("Mise à jour du certificat ...");
			const oldStatus = this.item.status;
			this.item.status = this.status;
			this.item.date = null;
			VIPCertificateRest.changeStatus(this.item).then(result => {
				if (result.success) {
					toaster.toast({ message: "Le certificat a été mis à jour", variant: "success" });
					this.$emit("saved", this.item);
					this.$root.$emit("vip-certificate-saved", this.item);
				} else {
					this.item.status = oldStatus;
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public save() {
		if (!this.canEdit || !this.item) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}

		this.item.event = createEventInfo();
		this.item.data = JSON.stringify(this.item.datas);
		this.item.date = null;
		let ips: number[] = this.item.ips.map(cip => cip.fk_ip);
		let isNew = this.isNew;

		busy.start("Sauvegarde du certificat ...");
		let p = isNew ? VIPCertificateRest.create(this.item) : VIPCertificateRest.update(this.item);
		p.then(result => {
			if (result.success && result.item) {
				return VIPCertificateIpRest.batch(result.item.id, ips);
			}
			return { success: false, items: [] };
		}).then(result => {
			if (result.success) {
				this.changed = false;
				this.unfocusAll();
				if (this.editor) {
					this.editor.setChanged(false);
				}
				toaster.toast({ message: "Le certificat a été sauvegardé", variant: "success" });
				if (isNew) {
					this.$emit("created", this.item);
					this.$root.$emit("vip-certificate-created", this.item);
				}
				this.$emit("saved", this.item);
				this.$root.$emit("vip-certificate-saved", this.item);
				return VIPCertificateRest.generatePDF(this.item);
			}
			return { success: false, item: undefined };
		}).then(result => {
			if (result.success) {
				toaster.toast({ message: "Le certificat PDF a été généré", variant: "success" });
				this.item.pdf = result.item || null;
				if (this.id !== this.item.id) {
					this.$router.push({ name: "Certificate", params: { id: this.item.id } });
				}
			}
		}).finally(() => {
			busy.stop();
		});
	}

	// public remove() {
	// 	if (!this.canDelete || !this.item) {
	// 		return;
	// 	}

	// 	this.item.event = createEventInfo();
	// 	let abandon = !this.item.isDraft;

	// 	this.$bvModal.msgBoxConfirm(`Êtes-vous sûr de vouloir ${abandon ? 'abandonner' : 'supprimer'} ce certificat ?`, {
	// 		title: `${abandon ? 'Abandon' : 'Suppression'} d'un certificat`,
	// 		cancelTitle: "Non",
	// 		cancelVariant: "outline-secondary",
	// 		okTitle: abandon ? "Abandonner" : "Supprimer",
	// 		okVariant: "danger",
	// 	}).then((result: boolean | null) => {
	// 		if (result && this.item) {
	// 			busy.start((abandon ? "Abandon" : "Suppression") + " du certificat ...");
	// 			VIPCertificateRest.delete(this.item, { force: !abandon }).then(result => {
	// 				if (result.success && this.item) {
	// 					this.changed = false;
	// 					toaster.toast({ message: `Le certificat a été ${abandon ? 'abandonné' : 'supprimé'}`, variant: "success" });
	// 					db.certificates.remove(this.item, true);
	// 					this.$router.push({ name: "Certificates" });
	// 				}
	// 			}).finally(() => {
	// 				busy.stop();
	// 			});
	// 		}
	// 	});
	// }

	public generate() {
		if (this.item && this.canEdit) {
			busy.set({ status: true, text: "Génération du certificat ..." })
			VIPCertificateRest.generatePDF(this.item).then(result => {
				if (result.success) {
					this.$emit("generated", this.item);
					this.$root.$emit("vip-certificate-generated", this.item);
					this.item.pdf = result.item;
					this.$bvModal.show("cert_pdf_modal");
				}
			}).finally(() => {
				busy.set({ status: false });
			});
		}
	}

	public uploadFile(file: File) {
		DEBUG && console.log({ canEdit: this.canEdit, canUpload: this.canUpload, item: this.item, file });
		if (this.canUpload && this.item) {
			busy.start("Sauvegarde du certificat ...");
			this.item.date = dayjs(this.date);
			this.item.event = createEventInfo();
			VIPCertificateRest.uploadPDF(this.item, file).then(result => {
				if (result.success) {
					this.$emit("saved", this.item);
					this.$root.$emit("vip-certificate-saved", this.item);
					toaster.toast({ message: "Certificat signé et mise en ligne avec succès !", variant: "success" });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public loadDependencies() {
		if (this.item) {
			if (!this.item.project) {
				VIPProjectRest.get({ id: this.item.fk_project }, { options: { company: { contacts: true }, ips: true, manager: true } });
			} else if (!this.item.project.company) {
				VIPCompanyRest.get({ id: this.item.project.fk_company }, { options: { contacts: true } });
			}
			if (!this.item.ips.length) {
				VIPCertificateIpRest.list(this.item.id);
			}
			if (!this.item.events.length) {
				VIPCertificateEventRest.list(this.item.id, { options: { event: true } });
			}
		}
	}

	@Watch("item", { immediate: true })
	public itemChanged(newValue?: VIPCertificate | null, oldValue?: VIPCertificate | null) {
		if (newValue !== oldValue) {
			this.date = newValue?.date?.format("YYYY-MM-DD") || null;
		}
	}
}
